import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=text&selected=Material+Symbols+Rounded:text_fields:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const TextFieldsIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Text Fields Icon</title>;
    t1 = <path d="M8.52775 19.5C8.23358 19.5 7.98233 19.3972 7.774 19.1915C7.56567 18.9858 7.4615 18.7361 7.4615 18.4423V6.625H3.56725C3.27075 6.625 3.01875 6.52142 2.81125 6.31425C2.60375 6.10708 2.5 5.8555 2.5 5.5595C2.5 5.2635 2.60283 5.01292 2.8085 4.80775C3.01417 4.60258 3.26392 4.5 3.55775 4.5H13.4808C13.7772 4.5 14.0292 4.60292 14.2367 4.80875C14.4442 5.01475 14.548 5.26475 14.548 5.55875C14.548 5.85292 14.4452 6.10417 14.2395 6.3125C14.0338 6.52083 13.7842 6.625 13.4905 6.625H9.5865V18.4327C9.5865 18.7292 9.48358 18.9812 9.27775 19.1888C9.07192 19.3962 8.82192 19.5 8.52775 19.5ZM17.4605 19.5C17.1663 19.5 16.9167 19.3972 16.7115 19.1915C16.5065 18.9858 16.404 18.7361 16.404 18.4423V11.577H14.4905C14.194 11.577 13.942 11.4733 13.7345 11.266C13.5268 11.0588 13.423 10.8073 13.423 10.5113C13.423 10.2153 13.5258 9.96475 13.7315 9.75975C13.9372 9.55458 14.1869 9.452 14.4808 9.452H20.4328C20.7292 9.452 20.9813 9.55492 21.1887 9.76075C21.3962 9.96658 21.5 10.2166 21.5 10.5107C21.5 10.8049 21.3972 11.0562 21.1915 11.2645C20.9858 11.4728 20.7361 11.577 20.4423 11.577H18.5193V18.4423C18.5193 18.7361 18.4163 18.9858 18.2105 19.1915C18.0045 19.3972 17.7545 19.5 17.4605 19.5Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};